import { Component } from '@angular/core';

@Component({
  selector: 'app-sms-verification-info',
  templateUrl: './sms-verification-info.component.html'
})
export class SmsVerificationInfoComponent {
  constructor() { }
}
